import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { allAgenciesSelector } from 'src/features/appSettings';

export const useAllAgenciesAsSelectData = () => {
  const allAgencies = useSelector(allAgenciesSelector);
  const agenciesData = useMemo(() => {
    if (!allAgencies) {
      return [];
    }

    return allAgencies.map((agency) => {
      return {
        value: agency.id,
        label: agency.name,
      };
    });
  }, [allAgencies]);

  return {
    agenciesData,
  };
};
